module.exports = "/_next/static/images/pricing-plans-consulting-service-1-de3be188b2fa1ef5c965f12f85eccc97.webp";